import { makeStyles } from '@material-ui/core'

const generateTicketCardStyles = makeStyles(theme => ({
  root: {
    height: 150,
    width: 380,
    borderRadius: theme.shape.borderRadius,
  },
  cardActionArea: {
    padding: theme.spacing(2.4),
    height: 150,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  cover: {
    flex: 1,
    width: 95,
    height: 95,
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))

export default generateTicketCardStyles
